import { AppState } from '~system/store/configure-store';

export const selectActiveDrawers = (state: AppState) => state.drawer.stack;
